interface MoveStatusState {
  statuses: { [key: string]: { is_moved: boolean } };
}

const initialState: MoveStatusState = {
  statuses: {},
};

/**
 * moveStatusReducer: Reducer to handle actions related to tracking move status of images.
 *
 * @param {MoveStatusState} state - The current state of the move statuses.
 * @param {any} action - The action dispatched to the reducer.
 * @returns {MoveStatusState} The new state after applying the action.
 */
const moveStatusReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_MOVE_STATUS":
      return {
        ...state,
        statuses: {
          ...state.statuses,
          [action.payload.key]: { is_moved: action.payload.is_moved },
        },
      };
    case "INITIALIZE_MOVE_STATUSES":
      return {
        ...state,
        statuses: {
          ...state.statuses,
          ...action.payload,
        },
      };
    case "RESET_MOVE_STATUSES":
      return {
        ...state,
        statuses: {},
      };
    default:
      return state;
  }
};

export default moveStatusReducer;